import { render, staticRenderFns } from "./approver_error.vue?vue&type=template&id=e1b111cc&scoped=true&"
import script from "./approver_error.vue?vue&type=script&lang=js&"
export * from "./approver_error.vue?vue&type=script&lang=js&"
import style0 from "./approver_error.vue?vue&type=style&index=0&id=e1b111cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b111cc",
  null
  
)

export default component.exports